import { BaseFrameworkError } from "@bloglovin/vue-framework";

class AutoplayError extends BaseFrameworkError {}

export default AutoplayError;
